import { apiCall, ApiConfig } from '../../config/api'
import { getTypesOrderAction } from '../actions/typeOrderActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { ApiResponse } from '../../typings/ApiResponse'
import { TypeOrder } from '../../interfaces/Order/TypeOrder'
import { GET_TYPE_ORDER } from '../types/typeOrderActionsTypes'

export function* getTypesOrderAsync() {
  try {
    const { status, data }: AxiosResponse<ApiResponse<TypeOrder>> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypesOrderApi}`
    )
    if (status === 200) {
      yield put(getTypesOrderAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypesOrderAction([], serverError.message))
  }
}

export function* watchGetTypesOrderAsync() {
  yield takeEvery(GET_TYPE_ORDER, getTypesOrderAsync)
}
